module.exports = __webpack_public_path__ + "files/cc85dad8c4b8dfd2c2b5e111f38f8fd7.svg";